import { useEffect, useState } from 'react'
import { Badge, Button, Col, Dropdown, Pagination, Spinner, Table } from 'react-bootstrap'
import { Title } from '../../../../Templates/Title'
import { humanizeDate } from '../../../../Utils/Dates/Dates'
import { BsEye, BsPersonWorkspace } from 'react-icons/bs'
import { getPlayers } from '../../Api/Players/Players'
import { GetPlayersProps, SinglePlayer } from '../../Api/Players/models'
import { EditPlayerModal } from './Components/EditPlayerModal'
import { CreateUserModal } from './Components/CreateUserModal'
import { CreateUserAndPlayerModal } from './Components/CreateUserAndPlayerModal'
import { RiFileDownloadLine } from 'react-icons/ri'
import { useExportPlayers } from './hooks/useExportPlayers'
import { useNavigate } from 'react-router-dom'

export interface HistoryFiltersForm {
    targetName: string;
    startDate: string;
    endDate: string;
    creatorName: string;
}
const defaultPageSize = 30

export const Players = () => {
    const navigate = useNavigate()
    const today = new Date().toISOString().split('T')[0]
    const twoMonthsAgo = new Date(new Date().setMonth(new Date().getMonth() - 2)).toISOString().split('T')[0]
    const defaultFilters: GetPlayersProps = {
        page: 1,
        pageSize: 30,
        startDate: twoMonthsAgo,
        endDate: today,
        createdInPromo: false,
        platformUser: '',
        hasPhone: false
    }

    // Modals
    const [showEditPlayerModal, setShowEditPlayerModal] = useState(false)
    const [playerToEdit, setPlayerToEdit] = useState<SinglePlayer | null>(null)
    const [showCreateUserModal, setShowCreateUserModal] = useState(false)
    const [showCreateUserAndPlayerModal, setShowCreateUserAndPlayerModal] = useState(false)

    // Pagination
    const [totalPages, setTotalPages] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

    // Data
    const [loading, setLoading] = useState(false)
    const [players, setPlayers] = useState<SinglePlayer[]>([])

    // Filters
    const [filters, setFilters] = useState<GetPlayersProps>({
        page: 1,
        pageSize: 30,
        startDate: twoMonthsAgo,
        endDate: today,
        createdInPromo: false,
        platformUser: '',
        hasPhone: false
    })

    const { handleDownload, loadingExport } = useExportPlayers({ filters })

    const fetchPlayers = async ({ page = 1, pageSize = 15, startDate = filters.startDate, endDate = filters.endDate, createdInPromo = false, platformUser = '', hasPhone = false }: GetPlayersProps) => {
        setLoading(true)
        const res = await getPlayers({ page, pageSize, startDate, endDate, createdInPromo, platformUser: platformUser?.trim(), hasPhone })
        if (res) {
            setPlayers(res.data)
            setTotalPages(res.totalPages)
            setCurrentPage(res.currentPage)
        }
        setLoading(false)
    }

    const handleSearch = () => {
        fetchPlayers({ ...filters, page: 1, pageSize: defaultPageSize })
    }


    const cleanFilters = () => {
        setFilters({ ...defaultFilters })
        fetchPlayers({ ...defaultFilters })
    }


    const handlePageChange = (page: number) => {
        setCurrentPage(page)
        fetchPlayers({ ...filters, page, pageSize: defaultPageSize })
    }


    const handleEditPlayer = (player: SinglePlayer) => {
        setPlayerToEdit(player)
        setShowEditPlayerModal(true)
    }

    const handleChat = (player: SinglePlayer) => {
        navigate(`/dashboard/chat?playerId=${player.id}`)
    }

    useEffect(() => {
        if (!showEditPlayerModal && !showCreateUserModal) {
            fetchPlayers({ ...defaultFilters })
        }
        // getAllCreators();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showEditPlayerModal, showCreateUserModal])

    return (
        <div className='pb-5 mt-4'>
            {showCreateUserModal && <CreateUserModal
                show={showCreateUserModal}
                onHide={() => setShowCreateUserModal(false)}
                player={playerToEdit}
            />}
            {showEditPlayerModal && <EditPlayerModal
                show={showEditPlayerModal}
                onHide={() => setShowEditPlayerModal(false)}
                player={playerToEdit}
            />}

            {showCreateUserAndPlayerModal && <CreateUserAndPlayerModal
                show={showCreateUserAndPlayerModal}
                onHide={() => setShowCreateUserAndPlayerModal(false)}
                player={playerToEdit}
            />}


            <div className='d-flex justify-content-between align-items-center'>
                <Title
                    title="Jugadores"
                    icon={<BsPersonWorkspace size={30} />}
                    subtitle="Registro de jugadores"
                />
                <Dropdown>
                    <Dropdown.Toggle variant="primary" id="dropdown-create-player">
                        Crear jugador
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setShowCreateUserModal(true)}>
                            Crear en Gestor
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setShowCreateUserAndPlayerModal(true)}>
                            Crear en Gestor y Plataforma
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
            <Col md={12} sm={12} className='mx-auto'>

                <div className='mb-3 mt-5'>
                    <div className="d-flex align-items-end justify-content-between flex-wrap gap-3">
                        <div className="d-flex gap-4 align-items-end">
                            <div>
                                <div className='d-flex gap-2'>
                                    <div className="d-flex flex-column align-items-start">
                                        <label htmlFor="platformUser" className="text-white mb-1"><small>Jugador</small></label>
                                        <input
                                            value={filters.platformUser}
                                            type="text"
                                            id="platformUser"
                                            name="platformUser"
                                            className="form-control text-white"
                                            onChange={(e) => setFilters({ ...filters, platformUser: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex gap-2'>
                                <div className="d-flex flex-column align-items-start">
                                    <label htmlFor="start" className="text-white mb-1"><small>Fecha inicio</small></label>
                                    <input
                                        value={filters.startDate}
                                        type="date"
                                        id="start"
                                        name="start"
                                        className="form-control text-white"
                                        onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                                    />
                                </div>
                                <div className="d-flex flex-column align-items-start">
                                    <label htmlFor="end" className="text-white mb-1"><small>Fecha fin</small></label>
                                    <input
                                        value={filters.endDate}
                                        type="date"
                                        id="end"
                                        name="end"
                                        className="form-control text-white"
                                        onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="checkbox"
                                        id="createdInPromo"
                                        checked={filters.createdInPromo}
                                        onChange={(e) => setFilters({ ...filters, createdInPromo: e.target.checked })}
                                    />
                                    <label htmlFor="createdInPromo" className="text-white"><small>Mostrar solo creados en promoción</small></label>
                                </div>
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="checkbox"
                                        id="hasPhone"
                                        checked={filters.hasPhone}
                                        onChange={(e) => setFilters({ ...filters, hasPhone: e.target.checked })}
                                    />
                                    <label htmlFor="hasPhone" className="text-white"><small>Mostrar solo con télefono</small></label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex gap-2 align-items-end justify-content-end">
                                <Button
                                    variant='primary'
                                    onClick={handleSearch}
                                    className='text-nowrap'
                                >
                                    Buscar
                                </Button>
                                <Button
                                    variant='secondary'
                                    onClick={cleanFilters}
                                    className='text-nowrap'
                                >
                                    Limpiar filtros
                                </Button>
                                <Button
                                    variant=''
                                    onClick={handleDownload}
                                    disabled={loadingExport}
                                    className='text-nowrap text-white border-secondary d-flex align-items-center gap-2'
                                >
                                    <RiFileDownloadLine size={18} /> Descargar Excel
                                </Button>
                            </div>

                        </div>
                    </div>
                </div>

                <div>
                    {loading &&
                        <div className='d-flex justify-content-center align-items-center flex-column text-primaryy' style={{ height: '20vh' }}>
                            <div className="mb-1">
                                Cargando página {currentPage}
                            </div>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    }
                    {!loading && <div>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th className='text-sm text-primary text-center'></th>
                                    <th className='text-sm text-primary text-center'>Fecha Creación</th>
                                    <th className='text-sm text-primary text-center'>Usuario</th>
                                    <th className='text-sm text-primary text-center'>Nombre</th>
                                    <th className='text-sm text-primary text-center'>Teléfono</th>
                                    <th className='text-sm text-primary text-center'>Email</th>
                                    <th className='text-sm text-primary text-center'>Primera Carga</th>
                                    <th className='text-sm text-primary text-center'>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {players?.map((row, index) => (
                                    <tr key={row.id}>
                                        <td className='text-sm text-secondary text-center'>{index + 1}</td>
                                        <td className='text-sm text-secondary text-center'>{humanizeDate(row.createdAt)}</td>
                                        <td className='text-sm text-primary text-center'>{row.platformUser}</td>
                                        <td className='text-sm text-primary text-center'>{row.firstName} {row.lastName}</td>
                                        <td className='text-sm text-primary text-center'>{row.phone}</td>
                                        <td className='text-sm text-primary text-center'>{row.email}</td>
                                        <td className='text-sm text-primary text-center'>{row.firstLoadValue === 0 ? '' : row.firstLoadValue}</td>
                                        <td className='text-sm text-primary text-center'>
                                            <div className='d-flex justify-content-center gap-2' role='button' onClick={() => handleEditPlayer(row)}>
                                                <BsEye size={18} /> Ver / Editar
                                            </div>
                                        </td>
                                    </tr>

                                ))}
                            </tbody>
                        </Table>
                        <div className='d-flex justify-content-center'>
                            <Pagination>
                                <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                                {currentPage > 3 && (
                                    <>
                                        <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
                                        <Pagination.Ellipsis disabled />
                                    </>
                                )}
                                {[...Array(totalPages)].slice(
                                    Math.max(0, currentPage - 3),
                                    Math.min(totalPages, currentPage + 2)
                                )?.map((_, index) => {
                                    const pageNumber = Math.max(1, currentPage - 2) + index;
                                    return (
                                        <Pagination.Item
                                            key={pageNumber}
                                            active={currentPage === pageNumber}
                                            onClick={() => handlePageChange(pageNumber)}
                                        >
                                            {pageNumber}
                                        </Pagination.Item>
                                    );
                                })}
                                {currentPage < totalPages - 2 && (
                                    <>
                                        <Pagination.Ellipsis disabled />
                                        <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>
                                    </>
                                )}
                                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                                <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                            </Pagination>
                        </div>
                    </div>}
                </div>
            </Col>
        </div >

    )
}
